import React, { Component } from "react";
import "./othernonmarkethome.css";
import { t } from "i18next";
import {
  BreadCrumb,
  Button,
  TitleView,
  SideModel,
} from "../../components";
import * as Bl from "../../../businesslogic";
import OtherHome from "../../../assets/svgs/fasset/other_home.svg";
import { INVESTMENT_CATEGORY } from "../../constants";
import { getFinancialNonMarketPath, getUserId } from "../../common";

const newInvestment = {
  investmentcategory: INVESTMENT_CATEGORY.OTHER_NONMARKET,
  currentvalue: 0,
  annualcontribution: 0,
  maturityyear: 0,
  maturityvalue: 0,
  expectedror: 0,
  userid: "",
  contributiongrowthrate: 0,
  investementtype: "YEAR",
  investmentdetails: [
    {
      isothernonmarkets: true,
      isfliberadvise: false
    },
  ],
  investmentdescription: "",
  fvatretirement: 0,
  maturityage: 0,
  userage: 0,
  isincludefinancialplan: false
};
class OtherNonMarketHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newInvestmentData: new Bl.Investment({ ...newInvestment, userid: getUserId() }),
      investmentData: [],
    };
  }

  onSelectItem(path) {
    this.props.navigate(path);
  }

  onPressAddProperty() {
    this.props.navigate("/othernonmarketdetail", {
      state: {
        investmentData: this.state.newInvestmentData,
        isEditView: false,
      },
    });
  }



  renderNavView() {
    const items = getFinancialNonMarketPath("Others");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const title = t("networthAssetsFNM6");
    return <TitleView title={title} />;
  }

  renderProfileView() {
    return (
      <div className="onh_profile_view">
        <img
          src={OtherHome}
          alt={t("networthAssetsFNM6")}
          className="onh_icon"
        />
        <div className="onh_add_property">
          <Button
            buttonName={t("onmButton")}
            onPressButton={this.onPressAddProperty.bind(this)}
          />
        </div>
      </div>
    );
  }

  renderContentView() {
    return (
      <div className="onh_content_view">
        {this.renderTitleView()}
        {this.renderProfileView()}
      </div>
    );
  }
  renderDrawerContent() {
    const headerTitle = t("financialPlan");
    const step = 1;
    return <SideModel step={step} headerTitle={headerTitle}></SideModel>;
  }
  render() {
    return (
      <div className="onh_container">
        {this.renderNavView()}
        {this.renderContentView()}
        {/* {this.renderDrawerContent()} */}
      </div>
    );
  }
}

export default OtherNonMarketHome;
